<template>
  <v-row justify="center" style="z-index: 9999">
    <v-dialog
      @keydown.esc="closeModal()"
      max-width="600px"
      v-model="isVisible"
      v-on:click:outside="closeModal"
      overlay-opacity="1"
      transition="slide-y-transition"
    >
      <v-card>
        <v-toolbar
          class="black--text d-flex justify-center"
          color="#fbc501"
          tile
        >
          <v-toolbar-title v-if="!isEdit">Dodaj INFO</v-toolbar-title>
          <v-toolbar-title v-else>Edytuj INFO</v-toolbar-title>
        </v-toolbar>
        <BlackButton
          fab
          small
          icon="times"
          iconMargin=""
          class="close"
          @click.native="closeModal()"
        />
        <ValidationObserver ref="obs" v-slot="{ invalid }" mode="eager">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12"
                  ><v-checkbox
                    color="#fbc501"
                    v-model="visible"
                    label="Widoczny"
                  ></v-checkbox
                ></v-col>
                <v-col cols="12" sm="12">
                  <VTextFieldWithValidation
                    rules="required"
                    v-model="name"
                    label="Nazwa"
                    color="indigo"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" sm="12">
                  <!-- <VTextAreaWithValidation
                    rules="required|max:4096"
                    label="Opis"
                    style="height: 300px"
                    v-model="description"
                    outlined
                    dense
                  /> -->
                  <html-editor
                    :editorId="`gadgetEditor`"
                    @contentchanged="handleHtmlEditorForProduct($event)"
                    :startContent="description"
                  />
                </v-col>
                <v-col cols="12" sm="12">
                  <VTextAreaWithValidation
                    rules="max:4096"
                    label="Cena"
                    style="height: 300px"
                    v-model="note"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" sm="12">
                  <VTextFieldWithValidation
                    rules="required"
                    v-model="link"
                    label="Link"
                    color="indigo"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" sm="12">
                  <v-file-input
                    ref="fileupload"
                    v-model="photo"
                    dense
                    outlined
                    rounded
                    label="Załącz zdjęcie"
                    :key="inputKey"
                    accept="image/png,image/jpeg"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="warning" text v-on:click="closeModal">
              <font-awesome-icon icon="times" class="mr-1" />
              Anuluj
            </v-btn>
            <v-btn
              v-if="!isEdit"
              color="success"
              text
              :disabled="invalid"
              v-on:click="addGadget()"
            >
              <font-awesome-icon icon="check" class="mr-1" />
              Dodaj INFO
            </v-btn>
            <v-btn
              v-else
              color="success"
              text
              :disabled="invalid"
              v-on:click="editGadget()"
            >
              <font-awesome-icon icon="check" class="mr-1" />
              Zapisz INFO
            </v-btn>
          </v-card-actions>
        </ValidationObserver>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import VTextFieldWithValidation from "../inputs/VTextFieldWithValidation";
import BlackButton from "../buttons/BlackButton";
import VTextAreaWithValidation from "../inputs/VTextAreaWithValidation.vue";
import HtmlEditor from "../HtmlEditor.vue";
export default {
  name: "ProductModal",
  props: ["isVisible", "isEdit"],

  components: {
    VTextFieldWithValidation,
    ValidationObserver,
    BlackButton,
    VTextAreaWithValidation,
    HtmlEditor,
  },
  data: () => ({
    name: "",
    description: "",
    visible: true,
    link: "",
    photo: null,
    inputKey: 0,
    note: "",
  }),
  computed: {
    gadget() {
      return this.$store.getters["gadgets/getGadget"];
    },
  },
  watch: {
    gadget: function () {
      this.name = this.gadget.name;
      this.link = this.gadget.link;
      this.description = this.gadget.description;
      this.visible = this.gadget.visible;
      this.note = this.gadget.note;
    },
  },
  methods: {
    handleHtmlEditorForProduct(newDescription) {
      this.description = newDescription;
    },
    closeModal() {
      this.name = "";
      this.link = "";
      this.description = "";
      this.visible = true;
      this.photo = null;
      this.note = "";
      this.inputKey++;
      this.$refs.obs.reset();
      this.$emit("closeModal");
    },
    async addGadget() {
      let formData = new FormData();
      if (this.photo) {
        formData.append("file", this.photo);
      }
      formData.append("name", this.name);
      formData.append("description", this.description);
      formData.append("visible", this.visible);
      formData.append("link", this.link);
      formData.append("note", this.note);
      await this.$store.dispatch("gadgets/addGadget", formData);
      this.closeModal();
    },
    async editGadget() {
      let formData = new FormData();
      if (this.photo) {
        formData.append("file", this.photo);
      }
      formData.append("name", this.name);
      formData.append("description", this.description);
      formData.append("visible", this.visible);
      formData.append("link", this.link);
      formData.append("note", this.note);
      let object = {
        id: this.gadget.id,
        formData: formData,
      };
      await this.$store.dispatch("gadgets/editGadget", object);
      this.closeModal();
    },
  },
};
</script>
<style lang="scss" scoped>
.outlined-form-section {
  position: relative;

  border-color: rgba(0, 0, 0, 0.38);
  border-width: 2px;
}

.outlined-form-section-title {
  top: -15px;
  left: 10px;
  position: absolute;

  padding: 0.2rem 0.5rem;

  background-color: white;

  font-size: 12px;
}
.close {
  position: absolute;
  top: 2%;
  right: 3%;
  z-index: 10000000;
}
// .v-overlay__scrim {
//   backdrop-filter: blur(5px) !important;
//   background-color: transparent !important;
// }
</style>
